import React from 'react';
import './TermsAndConditions.css';

const TermsAndConditions = () => {
    return (
        <div className="terms-container">
            <h1>Termos e Condições</h1>

            <p>
                Estes Termos e Condições regulam o acesso e a utilização da loja online da empresa
                <strong> N.WAYAMI COMÉRCIO GERAL E PRESTAÇÃO DE SERVIÇOS</strong>, pessoa coletiva com
                o NIF: 5002061422, com sede em Luanda, Centralidade do Kilamba, Rua Quarteirão F, Apartamento 91, 9º andar.
                Ao utilizar o site <strong>www.store.nwayami.com</strong>, o Cliente concorda com os termos descritos neste documento.
            </p>

            <h2>A. Informação Geral sobre os Produtos Comercializados</h2>

            <h3>1. Imagens</h3>
            <p>
                As imagens utilizadas no site têm apenas um propósito ilustrativo. Embora nos esforcemos por apresentar os produtos de forma precisa, podem existir diferenças entre a imagem e o produto real. Tais variações não constituem obrigação contratual para a N.WAYAMI.
            </p>

            <h3>2. Descrições de Produtos</h3>
            <p>
                As descrições disponibilizadas são baseadas nas informações fornecidas pelos fabricantes e fornecedores dos produtos. A N.WAYAMI não se responsabiliza por eventuais imprecisões ou alterações nestas descrições.
            </p>

            <h3>3. Fichas Técnicas</h3>
            <p>
                As especificações técnicas dos produtos são de responsabilidade exclusiva dos respetivos fabricantes. A N.WAYAMI publica essas informações conforme recebidas, e não pode garantir sua total exatidão ou atualidade.
            </p>

            <h3>4. Políticas de Privacidade dos Fabricantes</h3>
            <p>
                Os conteúdos informativos publicados pelos fabricantes são baseados em fontes internas e podem ser alterados a qualquer momento, sem aviso prévio. A N.WAYAMI não se responsabiliza por alterações feitas pelos fabricantes em suas políticas ou documentos.
            </p>

            <h3>5. Manuais de Utilização</h3>
            <p>
                Os manuais fornecidos com os produtos são elaborados pelos fabricantes e disponibilizados tal como nos foram entregues. A N.WAYAMI não se responsabiliza por erros ou omissões que possam existir nesses documentos.
            </p>

            <h2>B. Condições Gerais de Venda</h2>

            <h3>1. Finalidade e Âmbito de Aplicação</h3>
            <p>
                Finalidade e Âmbito de Aplicação
                Estas condições regulam o uso dos serviços fornecidos pela nwayami através do sítio www.store.nwayami.com, incluindo a venda de produtos como electrónica, informática, electrodomésticos, áudio, vídeo, telemóveis, entre outros.

                Todas as compras efectuadas através do referido sítio e cujo pagamento seja feito em AKZ por via de transferência bancária ou pagamento via Multicaixa, são consideradas vendas da nwayami.

                As condições aqui descritas vinculam ambas as partes a partir do momento da confirmação da encomenda pelo Cliente.

                A nwayami reserva-se o direito de rever estas condições a qualquer momento, sendo válidas as vigentes à data da confirmação da encomenda.
            </p>
            <h3>2. Objecto</h3>
            <p>
                Estas Condições Gerais regulam a prestação dos serviços de venda de produtos e contratação de serviços oferecidos pela nwayami, bem como a divulgação da sua marca junto dos Clientes/utilizadores, através do sítio www.store.nwayami.com.
            </p>
            <h3>Condições Legais e Responsabilidade</h3>
            <p>
                3.1. Transparência da Informação
                A nwayami disponibiliza, por meios electrónicos, informações relativas à sua identidade, endereço, e dados contratuais dos Clientes.
            </p>
            <p>
                3.2. Confidencialidade dos Dados
                A nwayami compromete-se a proteger os dados pessoais dos Clientes e a usá-los exclusivamente no âmbito da prestação dos seus serviços.
            </p>
            <p>
                3.3. Segurança no Tratamento de Dados
                A nwayami adopta medidas técnicas adequadas para garantir a segurança dos dados dos seus Clientes.
            </p>
            <p>3.4. Publicidade e Ofertas
                Mediante autorização do Cliente, a nwayami poderá enviar campanhas, ofertas e novidades por e-mail ou outro canal de comunicação autorizado.
            </p>
            <h3>Condições de Acesso</h3>
            <p>
                Qualquer utilizador pode consultar o sítio livremente. No entanto, certas promoções e ofertas são exclusivas a Clientes registados. O conteúdo do sítio está protegido por direitos de propriedade intelectual e não pode ser usado sem consentimento
            </p>
            <h3>Registo do Cliente</h3>
            <p>

Para comprar, o Cliente deve fornecer dados pessoais obrigatórios. É disponibilizado um sistema de registo com e-mail e senha, cuja confidencialidade é de responsabilidade do Cliente.

            </p>
            <h3>Processo de Compra</h3>
            <p>6.1. Preço
            Os preços apresentados são finais e incluem transporte, seguro e impostos. Estão sujeitos a alteração até ao momento da finalização da compra.
            </p>
            <p>
            6.2. Selecção e Finalização
            O Cliente selecciona produtos, define a morada de envio, escolhe o método de pagamento e aceita os termos antes de concluir a compra.

            </p>
            <p>6.3. Confirmação
            Após o pagamento, o Cliente recebe confirmação por e-mail. A encomenda é processada após validação do pagamento.
            </p>
            <p>
            6.4. Disponibilidade dos Produtos
            Em caso de indisponibilidade de stock, o Cliente será reembolsado no prazo de até 20 dias.
            </p>
            <p>
            6.5. Pagamentos
            São aceites transferências bancárias, depósitos e pagamentos via Multicaixa. Os comprovativos devem ser enviados à nwayami.

            </p>
            <p>
            6.6. Facturação
            A factura é emitida com os dados fornecidos pelo Cliente. Não é possível alterar os dados após emissão.
            </p>
            <p>
            6.7. Prazo e Modo de Entrega
            O prazo médio de entrega em Luanda é de 3 dias úteis. Entregas fora de Luanda são feitas via transportadoras parceiras. A entrega requer assinatura e identificação do destinatário.

            </p>
            <p>6.8. Anomalias na Entrega
            Erros ou danos na mercadoria devem ser comunicados no momento da entrega e reportados à nwayami em até 24 horas.
            </p>
            <h3>Garantia</h3>
            <p>

Os produtos possuem garantia legal e a assistência é prestada pelos fabricantes. A nwayami actua como mediadora no processo.
            </p>
            <h3>Direitos do Cliente</h3>
            <p>
            8.1. Confidencialidade
            Os dados são tratados com confidencialidade. O Cliente pode aceder, alterar ou solicitar a eliminação dos seus dados.

            </p>
            <p>
            8.2. Devoluções
            O Cliente pode devolver produtos até 7 dias após recepção, desde que estejam em perfeitas condições. Certos produtos não são elegíveis para devolução.

            </p>
            <h3>
            Obrigações do Cliente
            </h3>
            <p>
            O Cliente deve manter os seus dados de acesso protegidos e utilizar o sítio conforme os termos legais.
            </p>
            <h3>
            Direitos da nwayami
            </h3>
            <p>
            A nwayami pode modificar, suspender ou cancelar serviços, preços ou encomendas conforme necessário.
            </p>
            <h3>
            Propriedade e Risco
            </h3>
            <p>

A propriedade dos produtos transfere-se com o pagamento. O risco passa com a entrega
            </p>
            <h3>
            Uso da Internet
            </h3>
            <p>
            A nwayami não se responsabiliza por falhas na rede, vírus ou interrupções alheias ao seu controlo.
            </p>
            <h3>Propriedade Intelectual
            </h3>
            <p>
            Todo o conteúdo do sítio pertence à nwayami ou a terceiros licenciados, estando protegido por lei.
            </p>
            <h3>
            Duração
            </h3>
            <p>
            Estas condições aplicam-se enquanto durarem os serviços de venda online da nwayami.
            </p>
            <h3>
            Acordo Total
            </h3>
            <p>

As presentes condições constituem o acordo integral entre as partes. A nulidade de uma cláusula não invalida as restantes.
            </p>
            <h3>
            Jurisdição
            </h3>
            <p>
            Os litígios emergentes serão resolvidos nos tribunais de Luanda, sob a lei angolana.
            </p>
            <h3>2. Processo de Compra</h3>
            <p>
                <strong>Seleção de Produtos:</strong> O Cliente pode adicionar, remover ou ajustar quantidades no carrinho de compras antes da confirmação.
                <br />
                <strong>Finalização:</strong> O Cliente deve fornecer dados pessoais, endereço de entrega e método de pagamento.
                <br />
                <strong>Confirmação:</strong> Ao concluir a encomenda, o Cliente aceita estes termos e recebe um e-mail de confirmação.
            </p>

            <h3>3. Preços e Pagamento</h3>
            <p>
                Os preços são exibidos em AKZ e incluem impostos e custos de transporte (salvo indicação contrária).
                <br />
                <strong>Métodos de pagamento:</strong>
                <br />
                - Transferência/depósito bancário (Angola)
                <br />
                - Multicaixa (Angola)
                <br />
                A encomenda só é validada após confirmação do pagamento.
            </p>

            <h3>4. Entrega</h3>
            <p>
                <strong>Prazo:</strong> Até 3 dias úteis para Luanda (após confirmação de pagamento).
                <br />
                <strong>Local:</strong> Endereço indicado pelo Cliente.
                <br />
                <strong>Atrasos:</strong> Em caso de atraso superior a 20 dias, o Cliente pode cancelar a encomenda e solicitar reembolso.
            </p>

            <h3>5. Garantia e Devoluções</h3>
            <p>
                <strong>Garantia:</strong> Conforme legislação vigente e políticas do fabricante.
                <br />
                <strong>Devolução:</strong>
                <br />
                - Prazo de 7 dias após recebimento (produtos não usados e na embalagem original)
                <br />
                - Exceções: Produtos higiênicos, softwares abertos ou itens personalizados
                <br />
                - Reembolso proporcional ao estado do produto
            </p>

            <h3>6. Direitos e Obrigações</h3>
            <p>
                <strong>Cliente:</strong> Deve fornecer dados corretos e conservar os produtos em caso de devolução.
                <br />
                <strong>Nwayami:</strong> Reserva-se o direito de cancelar encomendas por falta de stock ou pagamento.
            </p>

            <h3>7. Jurisdição</h3>
            <p>
                Estes termos são regidos pela lei angolana. Eventuais litígios serão resolvidos no Tribunal Judicial de Luanda.
            </p>

            <h2>Contato</h2>
            <p>
                Para qualquer dúvida relacionada a estes Termos e Condições, entre em contato conosco através do email:
                <strong> info@store.nwayami.com</strong>
                <br />
                WhatsApp: <strong>[inserir contacto]</strong>
                <br />
                Telefone: <strong>[inserir número]</strong>
            </p>
        </div>
    );
};

export default TermsAndConditions;